import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import { IProject } from "../model/top.model";
import { ENV } from '@app/env';

@Injectable()
export class ProjectData {
  projects: Array<IProject> = [];
  apiUrl: string = ENV.apiUrl;

  constructor(
    public http: HttpClient,
    public storage: Storage
  ) { }

  getProjects(): Promise<Array<IProject>> {
    let projectObject = {
      operation: "ALL",
    };
    return new Promise((resolve) => {
      // logic for http request to backend service
      this.http.post<IProject[]>(
        this.apiUrl + "projects/",
        JSON.stringify(projectObject)
      ).subscribe((response) => {
        this.projects = response;
        resolve(response);
      }, (error) => {
        resolve(null);
      });
    });
  }

  createProject(project: IProject): Promise<Array<IProject>> {
    project.operation = "POST";
    return new Promise((resolve) => {
      this.http.post(
        this.apiUrl + "projects/",
        JSON.stringify(project)
      ).subscribe((response) => {
        project.project_id = response[0].project_id;
        this.projects.push(project);
        resolve(response[0]);
      }, (error) => {
        resolve(null);
      });
    });
  }

  getProject(projectId: string): Promise<IProject> {
    let projectObject = {
      operation: "GET",
      project_id: projectId,
    };
    return new Promise((resolve) => {
      this.http.post(
        this.apiUrl + "projects/",
        JSON.stringify(projectObject)
      ).subscribe((response) => {
        resolve(response[0]);
      }, (error) => {
        resolve(null);
      });
    });
  }

  setProject(project: IProject): Promise<Array<IProject>> {
    project.operation = "PUT";
    return new Promise((resolve) => {
      this.http.post(
        this.apiUrl + "projects/",
        JSON.stringify(project)
      ).subscribe((response) => {
        for (let projectKey in this.projects) {
          if (this.projects[projectKey].project_id == response[0].project_id) {
            this.projects[projectKey] = response[0];
            break;
          }
        }
        resolve(response[0]);
      }, (error) => {
        resolve(null);
      });
    });
  }

  deleteProject(project: IProject): Promise<Array<IProject>> {
    project.operation = "DELETE";
    return new Promise((resolve) => {
      this.http.post(
        this.apiUrl + "projects/",
        JSON.stringify(project)
      ).subscribe((response) => {
        let foundIndex = this.projects.indexOf(project);
        if (foundIndex > -1) {
          this.projects.splice(foundIndex, 1);
        }
        resolve(response[0]);
      }, (error) => {
        resolve(null);
      });
    });
  }

  filterProjects(name: string): IProject[] {
    return this.projects.filter((project) => {
      return project.name.toLowerCase().indexOf(name.toLowerCase()) > -1;
    });
  }

  /**
   * Helper method to make a unique clone of an object
   */
  cloneObject(obj) {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.cloneObject(obj[i]);
      }
      return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = this.cloneObject(obj[attr]);
      }
      return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
  }
}



// WEBPACK FOOTER //
// ./src/providers/project-data.ts